export const VEHICLE_ATTRIBUTE_IDS = {
    ENGINE: 10011,
    SUBMODEL: 10028,
};

export const NO_AVAILABLE_FITMENT_YEAR_VALUES = new Set([99, '99']);
